import { Flex, Spinner, Text } from "@chakra-ui/react"

export default function LoadingIndicator({ container, spinner, label, color = "color2", labelColor = "gray.400" }) {
    return (
        <Flex align="center" justify="center" height={44} direction="column" {...container}>
            <Spinner thickness="2px" speed="0.65s" color={color} emptyColor="transparent" size="xl" {...spinner} />
            {label && (
                <Text color={labelColor} mt={2} textAlign="center">
                    {label}
                </Text>
            )}
        </Flex>
    )
}
